import { render, staticRenderFns } from "./MhfPage.vue?vue&type=template&id=8113d618&"
import script from "./MhfPage.vue?vue&type=script&lang=js&"
export * from "./MhfPage.vue?vue&type=script&lang=js&"
import style0 from "./MhfPage.vue?vue&type=style&index=0&id=8113d618&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports